import { render, staticRenderFns } from "./RulePopUp.vue?vue&type=template&id=24c96ce4&scoped=true&"
import script from "./RulePopUp.vue?vue&type=script&lang=js&"
export * from "./RulePopUp.vue?vue&type=script&lang=js&"
import style0 from "./RulePopUp.vue?vue&type=style&index=0&id=24c96ce4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c96ce4",
  null
  
)

export default component.exports